import { Attr, BelongsTo, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';
import Workstation from './workstation';

@Model()
export default class WorkstationIdleShutdownToggle extends ApplicationRecord {
  static jsonapiType = 'workstation_idle_shutdown_toggles';
  @Attr() enableIdleShutdown: boolean;
  @Attr() timeout: number;

  @BelongsTo() workstation: Workstation;
}
